export function isNil<T>(value: T | null | undefined): value is null | undefined {
    return value === null || value === undefined;
}

export function isDefined<T>(value: T): value is Exclude<T, null | undefined> {
    return !isNil(value);
}
